import { Components } from '@mui/material';

import tokens from '../tokens';

const MuiListItemIcon: NonNullable<Components['MuiListItemIcon']> = {
  defaultProps: {},
  styleOverrides: {
    root: {
      color: tokens.palette.text.primary,
    },
  },
};

export default MuiListItemIcon;
